var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#33ff33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73255 5.3329H13.9994C14.7358 5.3329 15.3327 5.92986 15.3327 6.66622V8.06915C15.3327 8.24328 15.2985 8.41575 15.2323 8.57682L13.1693 13.5867C13.0665 13.8365 12.823 13.9995 12.5529 13.9995H1.33268C0.964496 13.9995 0.666016 13.7011 0.666016 13.3329V6.66622C0.666016 6.29804 0.964496 5.99957 1.33268 5.99957H3.65391C3.87053 5.99957 4.07364 5.89432 4.19856 5.71736L7.83415 0.566919C7.92915 0.43234 8.10822 0.387334 8.25555 0.461004L9.46495 1.06569C10.166 1.41624 10.5281 2.20796 10.3348 2.96758L9.73255 5.3329ZM4.66602 7.05788V12.6662H12.1064L13.9994 8.06915V6.66622H9.73255C8.86275 6.66622 8.22588 5.84687 8.44042 5.00396L9.04262 2.63864C9.08128 2.48672 9.00888 2.32837 8.86862 2.25826L8.42788 2.03788L5.28785 6.48627C5.12125 6.72228 4.90829 6.91575 4.66602 7.05788ZM3.33268 7.33288H1.99935V12.6662H3.33268V7.33288Z",
    fill: "#20262B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/likes.ffd23be80c492ca56744d571d8902666.svg";
export { ForwardRef as ReactComponent };